import { Appointment } from "@elixir/types";
import useQueueStore from "../../../../stores/queue-store";
import RightPanelCard from "../right-panel-card";
import { Fragment } from "react";
import useCanShowOnboardingChange from "../../../../hooks/use-can-show-onboarding-change";
import useReactXarrows from "../../../../hooks/use-react-xarrows";
import {
  CREATE_CUSTOM_QUEUE_BUTTON_ID,
  EDIT_QUEUE_BUTTON_ID,
} from "../../../../organisms/queue/right-queue-panel";

export const CHECKIN_ID = "checkin";
export const VIEW_AND_MANAGE_CHECKIN_PATIENTS_ID =
  "view-and-manage-checkin-patients";
export const CREATE_QUEUE_THAT_FITS_WORKFLOW_ID =
  "create-queue-that-fits-workflow";
export const MANAGE_HOW_QUEUE_LOOKS_ID = "manage-how-queue-looks";

const RightPanelQueueCard = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => {
  const canShowOnboardingChange = useCanShowOnboardingChange();
  const { showArrows, ReactXarrowsWrapper } = useReactXarrows();
  const setShowCustomiseYourQueue = useQueueStore(
    (state) => state.setShowCustomiseYourQueue
  );

  return (
    <div className="dr-w-full dr-h-full dr-flex dr-flex-col dr-items-center dr-justify-between dr-p-36">
      {canShowOnboardingChange ? (
        <div className="dr-w-full dr-h-full dr-flex dr-justify-between dr-items-start">
          <div
            className="dr-mt-120 dr-pt-16"
            id={VIEW_AND_MANAGE_CHECKIN_PATIENTS_ID}
          >
            <img
              src="/images/queue-page/view-and-manage-checkin-patients.webp"
              alt="view and manage checkin patients"
              style={{ width: "198px", height: "56px" }}
            />
          </div>
          <div
            className="dr-mt-30 dr-pt-16"
            id={CREATE_QUEUE_THAT_FITS_WORKFLOW_ID}
          >
            <img
              src="/images/queue-page/create-queue-that-fits-workflow.webp"
              alt="create queue that fits workflow"
              style={{ width: "218px", height: "56px" }}
            />
          </div>
          <div className="dr-mt-60 dr-pt-16" id={MANAGE_HOW_QUEUE_LOOKS_ID}>
            <img
              src="/images/queue-page/manage-how-queue-looks.webp"
              alt="manage how queue looks"
              style={{ width: "134px", height: "56px" }}
            />
          </div>
          {showArrows && ReactXarrowsWrapper && (
            <Fragment>
              <ReactXarrowsWrapper.Xarrow
                start={CHECKIN_ID}
                end={VIEW_AND_MANAGE_CHECKIN_PATIENTS_ID}
                color="#dedcdc"
                strokeWidth={2}
                path="smooth"
                curveness={0.5}
                startAnchor="bottom"
                endAnchor="top"
                animateDrawing={true}
              />

              <ReactXarrowsWrapper.Xarrow
                start={CREATE_CUSTOM_QUEUE_BUTTON_ID}
                end={CREATE_QUEUE_THAT_FITS_WORKFLOW_ID}
                color="#dedcdc"
                strokeWidth={2}
                path="smooth"
                curveness={0.8}
                startAnchor="bottom"
                endAnchor="top"
                animateDrawing={true}
              />

              <ReactXarrowsWrapper.Xarrow
                start={EDIT_QUEUE_BUTTON_ID}
                end={MANAGE_HOW_QUEUE_LOOKS_ID}
                color="#dedcdc"
                strokeWidth={2}
                path="smooth"
                curveness={0.8}
                startAnchor="bottom"
                endAnchor="top"
                animateDrawing={true}
              />
            </Fragment>
          )}
        </div>
      ) : (
        <div className="dr-w-full dr-flex dr-flex-col dr-items-center dr-justify-between dr-flex-1 dr-space-y-40">
          <div className="TouchCalloutRegular dr-text-darwin-touch-neutral-1000 dr-space-x-8">
            <span className="dr-text-darwin-touch-primary-primary">
              {title}
            </span>
            <span>{subtitle}</span>
          </div>
          <div className="dr-space-y-40 dr-w-full">
            <div className="dr-rounded-16 dr-bg-darwin-touch-neutral-0 dr-p-16 dr-space-y-16 dr-opacity-70">
              <div className="TouchSubheadlineRegular dr-text-darwin-touch-neutral-1000">
                Personalise your {title.slice(0, -1)} Queue
              </div>
              <RightPanelCard
                emptyState
                apt={
                  {
                    aid: "dfasdfas",
                    visit_end: new Date(),
                    visit_start: new Date(),
                    visit_checkin: new Date(),
                    token: 1,
                    patient: {
                      fln: "Name | Gender | Age",
                      mobile: "9999999999",
                    },
                    formData: [{ key: "uhid", value: "UHID" }],
                  } as Appointment
                }
                className=" dr-pointer-events-none"
              />
            </div>
            <div className="dr-space-y-8 dr-self-start dr-invisible">
              <div className="TouchSubheadlineRegular dr-text-darwin-touch-neutral-1000">
                How to personalise:
              </div>

              <ol className="TouchFootnoteRegular dr-text-darwin-touch-neutral-600">
                <li>
                  Make sure you are in{" "}
                  <span
                    className="dr-text-darwin-touch-primary-primary dr-cursor-pointer hover:dr-underline"
                    onClick={() => {
                      setShowCustomiseYourQueue(true);
                    }}
                  >
                    Customise
                  </span>{" "}
                  Panel
                </li>
                <li>
                  Select the Columns and Actions you wish to have on Queue Card
                </li>
                <li>Drag to sort their position</li>
                <li>
                  That’s it! You now have your own personalised Queue Card
                </li>
              </ol>
              <style>{`
              ol.d {list-style: numeric inside;}
            `}</style>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RightPanelQueueCard;
